// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/vision_presence.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file vision/projects/v1/vision_presence.proto.
 */
export const file_vision_projects_v1_vision_presence: GenFile = /*@__PURE__*/
  fileDesc("Cih2aXNpb24vcHJvamVjdHMvdjEvdmlzaW9uX3ByZXNlbmNlLnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxKpcBChJWaXNpb25QcmVzZW5jZUtpbmQSIAocVklTSU9OX1BSRVNFTkNFX0tJTkRfVU5LTk9XThAAEh8KG1ZJU0lPTl9QUkVTRU5DRV9LSU5EX1VQREFURRABEh4KGlZJU0lPTl9QUkVTRU5DRV9LSU5EX0hFTExPEAISHgoaVklTSU9OX1BSRVNFTkNFX0tJTkRfTEVBVkUQA2IGcHJvdG8z");

/**
 * @generated from enum protos.vision.projects.v1.VisionPresenceKind
 */
export enum VisionPresenceKind {
  /**
   * @generated from enum value: VISION_PRESENCE_KIND_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: VISION_PRESENCE_KIND_UPDATE = 1;
   */
  UPDATE = 1,

  /**
   * @generated from enum value: VISION_PRESENCE_KIND_HELLO = 2;
   */
  HELLO = 2,

  /**
   * @generated from enum value: VISION_PRESENCE_KIND_LEAVE = 3;
   */
  LEAVE = 3,
}

/**
 * Describes the enum protos.vision.projects.v1.VisionPresenceKind.
 */
export const VisionPresenceKindSchema: GenEnum<VisionPresenceKind> = /*@__PURE__*/
  enumDesc(file_vision_projects_v1_vision_presence, 0);

